import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b0b622d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-health-records-root-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Zdravlje ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "action" }
const _hoisted_12 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorHealthRecordsRootListFormCreateIndexVue = _resolveComponent("AppAdministratorHealthRecordsRootListFormCreateIndexVue")!
  const _component_AppAdministratorHealthRecordsRootListFormLookupDocumentIndexVue = _resolveComponent("AppAdministratorHealthRecordsRootListFormLookupDocumentIndexVue")!
  const _component_AppAdministratorHealthRecordsRootListFormUploadDocumentIndexVue = _resolveComponent("AppAdministratorHealthRecordsRootListFormUploadDocumentIndexVue")!
  const _component_AppAdministratorHealthRecordsRootListFormUpdateIndexVue = _resolveComponent("AppAdministratorHealthRecordsRootListFormUpdateIndexVue")!
  const _component_AppAdministratorHealthRecordsRootListFormRemoveIndexVue = _resolveComponent("AppAdministratorHealthRecordsRootListFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorHealthRecordsRootListFormCreateIndexVue, {
          players: _ctx.players,
          onGetHealthRecords: _ctx.getHealthRecords
        }, null, 8, ["players", "onGetHealthRecords"])
      ]),
      (_ctx.healthRecords.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.healthRecords, (healthRecord) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: healthRecord.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(healthRecord.user.content.name) + " " + _toDisplayString(healthRecord.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.moment(healthRecord.content.date_of_injury).format('DD.MM.YYYY.')), 1),
                    (healthRecord.content.date_of_recovery)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " - " + _toDisplayString(_ctx.moment(healthRecord.content.date_of_recovery).format('DD.MM.YYYY.')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, " - na rehabilitaciji "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (healthRecord.health_record_documents.length)
                    ? (_openBlock(), _createBlock(_component_AppAdministratorHealthRecordsRootListFormLookupDocumentIndexVue, {
                        key: 0,
                        healthRecord: healthRecord
                      }, null, 8, ["healthRecord"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_AppAdministratorHealthRecordsRootListFormUploadDocumentIndexVue, {
                    healthRecord: healthRecord,
                    onGetHealthRecords: _ctx.getHealthRecords
                  }, null, 8, ["healthRecord", "onGetHealthRecords"]),
                  _createVNode(_component_AppAdministratorHealthRecordsRootListFormUpdateIndexVue, {
                    healthRecord: healthRecord,
                    onGetHealthRecords: _ctx.getHealthRecords
                  }, null, 8, ["healthRecord", "onGetHealthRecords"]),
                  _createVNode(_component_AppAdministratorHealthRecordsRootListFormRemoveIndexVue, {
                    healthRecord: healthRecord,
                    onGetHealthRecords: _ctx.getHealthRecords
                  }, null, 8, ["healthRecord", "onGetHealthRecords"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Nema podataka... "))
    ])
  ]))
}